import React, { Component, useState } from "react";
import { Navigate } from "react-router-dom";
import { SideMenu } from "./SideMenu";
import { LoadSpinner } from "./LoadSpinner";
import Chart from "chart.js/auto";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Bar, Doughnut, Line, Pie } from "react-chartjs-2";
import DatePicker from "react-date-picker";
import DateTimePicker from "react-datetime-picker";
import { CategoryScale } from "chart.js";

import {
  InputGroup,
  Stack,
  FormControl,
  Button,
  ButtonToolbar,
  Form,
  Row,
  Col,
  Nav,
  Table,
  Navbar,
  Modal,
} from "react-bootstrap";

import { Link } from "react-router-dom";

import CartContext from "./CartContext";

//https://www.c-sharpcorner.com/article/create-different-charts-in-react-using-chart-js-library/
export class Home extends Component {
  static contextType = CartContext;
  constructor(props) {
    super(props);
    this.state = {
      dashboardSummary: "",
      orderSummary: "",
      revenueSummary: "",
      customerSummary: "",
      totalCustomerAccessSummary: "",
      topProductsSummary: "",
      purchaseOrderSummary: "",
      purchaseOrderExpensesSummary: "",
      rawMaterialPurchaseOrderSummary: "",
      rawMaterialPurchaseOrderExpensesSummary: "",
      customDate: new Date(),
      dateSelection: "Today",
      loadSpinnerOpen: false,
      msgboxOpen: false,
      msgboxTitle: "",
      msgboxMessage: "",
      firstLoad: false,
      showElasticCart: true,
      data: {
        datasets: [
          {
            data: [10, 20, 30],
          },
        ],
        labels: ["Red", "Yellow", "Blue"],
      },
    };
    ChartJS.register(CategoryScale, ArcElement, Tooltip, Legend);
  }

  ShowLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: true });
  };
  HideLoadSpinner = () => {
    this.setState({ loadSpinnerOpen: false });
  };
  ShowMessagBox = (title, message) => {
    this.setState({ msgboxOpen: true });
    this.setState({ msgboxTitle: title });
    this.setState({ msgboxMessage: message });
  };
  CloseMessagBoxCallback = () => {
    this.setState({ msgboxOpen: false });
  };

  OnDateSelectionChange = (e) => {
    const { name, value } = e.target;

    this.setState({ dateSelection: value }, () => {
      this.LoadDashboard();
    });
  };

  LoadDashboard = () => {
    this.GetDashboardSummary();
    this.GetOrderSummary();
    this.GetRevenueSummary();
    this.GetCustomerSummary();
    this.GetTopSellingProductsSummary();
    this.GetPurchaseOrderSummary();
    this.GetPurchasesOrderExpensesSummary();
    this.GetRawMaterialPurchaseOrderSummary();
    this.GetRawMaterialPurchasesOrderExpensesSummary();
    this.GetTotalCustomerAccessSummary();
  };

  GetDashboardSummary = () => {
    fetch(
      process.env.REACT_APP_API +
        "StoreManager/GetDashboardSummary/" +
        this.context.storeId +
        "/" +
        this.state.dateSelection +
        "/" +
        this.context.GetTicks(this.state.customDate)
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          this.setState({ dashboardSummary: data });
        }
      })
      .catch((error) => {});
  };

  GetOrderSummary = () => {
    fetch(
      process.env.REACT_APP_API +
        "StoreManager/GetOrderSummary/" +
        this.context.storeId +
        "/" +
        this.state.dateSelection +
        "/" +
        this.context.GetTicks(this.state.customDate)
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          data.datasets[0].label = "Orders";
          data.datasets[0].borderColor = "rgb(0, 192, 0)";
          data.datasets[0].backgroundColor = "rgb(0, 0, 192)";
          data.datasets[0].fill = false;
          data.datasets[0].lineTension = 0.1;
          this.setState({ orderSummary: data });
        }
      })
      .catch((error) => {
        // alert("GetOrderSummary Error");
      });
  };

  GetRevenueSummary = () => {
    fetch(
      process.env.REACT_APP_API +
        "StoreManager/GetRevenueSummary/" +
        this.context.storeId +
        "/" +
        this.state.dateSelection +
        "/" +
        this.context.GetTicks(this.state.customDate)
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          data.datasets[0].label = "Revenues";
          data.datasets[0].borderColor = "rgb(0, 255, 0)";
          data.datasets[0].backgroundColor = "rgb(0, 255, 0)";
          data.datasets[0].fill = false;
          data.datasets[0].lineTension = 0.1;
          this.setState({ revenueSummary: data });
        }
      })
      .catch((error) => {
        // alert("GetRevenueSummary Error");
      });
  };

  GetPurchaseOrderSummary = () => {
    fetch(
      process.env.REACT_APP_API +
        "StoreManager/GetPurchaseOrderSummary/" +
        this.context.storeId +
        "/" +
        this.state.dateSelection +
        "/" +
        this.context.GetTicks(this.state.customDate)
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          data.datasets[0].label = "Orders";
          data.datasets[0].borderColor = "rgb(255, 0, 0)";
          data.datasets[0].backgroundColor = "rgb(100, 100, 100)";
          data.datasets[0].fill = false;
          data.datasets[0].lineTension = 0.01;
          this.setState({ purchaseOrderSummary: data });
        }
      })
      .catch((error) => {
        // alert("GetOrderSummary Error");
      });
  };
  GetPurchasesOrderExpensesSummary = () => {
    fetch(
      process.env.REACT_APP_API +
        "StoreManager/GetPurchasesOrderExpensesSummary/" +
        this.context.storeId +
        "/" +
        this.state.dateSelection +
        "/" +
        this.context.GetTicks(this.state.customDate)
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          data.datasets[0].label = "Revenues";
          data.datasets[0].borderColor = "rgb(0, 255, 0)";
          data.datasets[0].backgroundColor = "rgb(255, 0, 0)";
          data.datasets[0].fill = false;
          data.datasets[0].lineTension = 0.1;
          this.setState({ purchaseOrderExpensesSummary: data });
        }
      })
      .catch((error) => {
        // alert("GetRevenueSummary Error");
      });
  };

  GetRawMaterialPurchaseOrderSummary = () => {
    fetch(
      process.env.REACT_APP_API +
        "StoreManager/GetRawMaterialPurchaseOrderSummary/" +
        this.context.storeId +
        "/" +
        this.state.dateSelection +
        "/" +
        this.context.GetTicks(this.state.customDate)
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          data.datasets[0].label = "Orders";
          data.datasets[0].borderColor = "rgb(255, 0, 0)";
          data.datasets[0].backgroundColor = "rgb(100, 100, 100)";
          data.datasets[0].fill = false;
          data.datasets[0].lineTension = 0.01;
          this.setState({ rawMaterialPurchaseOrderSummary: data });
        }
      })
      .catch((error) => {
        // alert("GetOrderSummary Error");
      });
  };
  GetRawMaterialPurchasesOrderExpensesSummary = () => {
    fetch(
      process.env.REACT_APP_API +
        "StoreManager/GetRawMaterialPurchasesOrderExpensesSummary/" +
        this.context.storeId +
        "/" +
        this.state.dateSelection +
        "/" +
        this.context.GetTicks(this.state.customDate)
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          data.datasets[0].label = "Revenues";
          data.datasets[0].borderColor = "rgb(0, 255, 0)";
          data.datasets[0].backgroundColor = "rgb(255, 0, 0)";
          data.datasets[0].fill = false;
          data.datasets[0].lineTension = 0.1;
          this.setState({ rawMaterialPurchaseOrderExpensesSummary: data });
        }
      })
      .catch((error) => {
        // alert("GetRevenueSummary Error");
      });
  };

  GetCustomerSummary = () => {
    fetch(
      process.env.REACT_APP_API +
        "StoreManager/GetCustomerSummary/" +
        this.context.storeId +
        "/" +
        this.state.dateSelection +
        "/" +
        this.context.GetTicks(this.state.customDate)
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          data.datasets[0].label = "Customers";
          data.datasets[0].borderColor = "rgb(255, 0, 0)";
          data.datasets[0].backgroundColor = "rgb(0, 192, 0)";
          data.datasets[0].fill = false;
          data.datasets[0].lineTension = 0.1;
          this.setState({ customerSummary: data });
        }
      })
      .catch((error) => {
        // alert("GetCustomersSummary Error");
      });
  };
  GetTotalCustomerAccessSummary = () => {
    fetch(
      process.env.REACT_APP_API +
        "StoreManager/GetTotalCustomerAccessSummary/" +
        this.context.storeId +
        "/" +
        this.state.dateSelection +
        "/" +
        this.context.GetTicks(this.state.customDate)
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          data.datasets[0].label = "Customers";
          data.datasets[0].borderColor = "rgb(255, 0, 0)";
          data.datasets[0].backgroundColor = "rgb(0, 192, 0)";
          data.datasets[0].fill = false;
          data.datasets[0].lineTension = 0.1;
          this.setState({ totalCustomerAccessSummary: data });
        }
      })
      .catch((error) => {});
  };
  GetTopSellingProductsSummary = () => {
    fetch(
      process.env.REACT_APP_API +
        "StoreManager/GetTopSellingProductsSummary/" +
        this.context.storeId +
        "/" +
        this.state.dateSelection +
        "/" +
        this.context.GetTicks(this.state.customDate)
    )
      .then((response) => response.json())
      .then((data) => {
        if (data.status == 400) {
        } else {
          // data.datasets[0].backgroundColor = ["#2FDE00", "#00A6B4", "#ff6600"];
          // data.datasets[0].hoverBackgroundColor = [
          //   "#175000",
          //   "#003350",
          //   "#993d00",
          // ];
          data.datasets[0].label = "products";
          data.datasets[0].borderColor = "rgb(100, 100, 100)";
          data.datasets[0].backgroundColor = "rgb(0, 0, 100)";
          this.setState({ topProductsSummary: data });
        }
      })
      .catch((error) => {
        // alert("GetCustomersSummary Error");
      });
  };

  fakeRequest = () => {
    return new Promise((resolve) => setTimeout(() => resolve(), 2000));
  };
  fakeRequest1 = () => {
    return new Promise((resolve) => setTimeout(() => resolve(), 2000));
  };

  componentDidMount() {
    window.scrollTo(0, 0);
    if (this.context.prods.length == 0) {
      this.fakeRequest1().then(() => {
        this.setState({ showElasticCart: false }); // showing the app
      });
      this.fakeRequest().then(() => {
        this.setState({ loadSpinnerOpen: false }); // showing the app
      });
    } else {
      this.setState({ showElasticCart: false }); // showing the app
      this.setState({ loadSpinnerOpen: false }); // showing the app
    }

    if (this.state.dashboardSummary == "" && this.context.storeId != "") {
      if (this.state.firstLoad == false) {
        this.state.firstLoad = true;
        this.GetDashboardSummary();
        this.GetOrderSummary();
        this.GetRevenueSummary();
        this.GetCustomerSummary();
        this.GetTopSellingProductsSummary();
        this.GetPurchaseOrderSummary();
        this.GetPurchasesOrderExpensesSummary();
        this.GetRawMaterialPurchaseOrderSummary();
        this.GetRawMaterialPurchasesOrderExpensesSummary();
        this.GetTotalCustomerAccessSummary();
      }
    }
  }

  divLoaded = (event) => {
    // alert(event.target.previousSibling.previousSibling.id);
  };

  render() {
    if (this.state.showElasticCart == true) {
      return (
        <>
          <ElasticCartAd></ElasticCartAd>
        </>
      );
    }
    if (this.context.userData.loginStatus != "active") {
      return <Navigate to="/UserLogin" />;
    }

    return (
      <>
        <div
          id="element_to_watch"
          className="Container-fluid mx-0 px-0"
          style={{
            backgroundImage: `background-image: url("data:image/svg+xml,<svg id='patternId' width='100%' height='100%' xmlns='http://www.w3.org/2000/svg'><defs><pattern id='a' patternUnits='userSpaceOnUse' width='40' height='40' patternTransform='scale(2) rotate(0)'><rect x='0' y='0' width='100%' height='100%' fill='hsla(0,0%,100%,1)'/><path d='M40 45a5 5 0 110-10 5 5 0 010 10zM0 45a5 5 0 110-10 5 5 0 010 10zM0 5A5 5 0 110-5 5 5 0 010 5zm40 0a5 5 0 110-10 5 5 0 010 10z'  stroke-width='1' stroke='hsla(153, 98%, 48%, 1)' fill='none'/><path d='M20 25a5 5 0 110-10 5 5 0 010 10z'  stroke-width='1' stroke='hsla(175, 98%, 48%, 1)' fill='none'/></pattern></defs><rect width='800%' height='800%' transform='translate(0,0)' fill='url(%23a)'/></svg>")`,
          }}
        >
          {this.state.loadSpinnerOpen === true ? (
            <LoadSpinner open="true"></LoadSpinner>
          ) : (
            ""
          )}
          {this.context.userData.loginStatus == "active" ? (
            <>
              <Row>
                {window.innerWidth > 1200 ? (
                  <>
                    <Col className="bg-light " style={{ width: "10px" }}>
                      <SideMenu></SideMenu>
                    </Col>
                  </>
                ) : (
                  <></>
                )}

                <Col xs={window.innerWidth > 1200 ? 10 : 12} className=" my-2 ">
                  <div className="border mb-3 text-center p-2 bg-light">
                    <h5>
                      <strong>STORE DETAILS</strong>
                    </h5>
                    {window.innerWidth > 1200 ? (
                      <>
                        <Table
                          bordered
                          className="bg-primary text-warning mb-0 "
                        >
                          <tbody>
                            <tr>
                              <td>
                                <div>
                                  Store Name
                                  <br />
                                  <span className="text-white">
                                    {this.context.store.name}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div>
                                  Store Expires on
                                  <br />
                                  <span className="blink_me text-white">
                                    {this.context.GetInDateFormat(
                                      new Date(this.context.store.storeEnd)
                                    )}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div>
                                  Product Type
                                  <br />
                                  <span className="text-white">
                                    {this.context.GetProductTypeNameById(
                                      this.context.store.productTypeId
                                    )}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div>
                                  License Model
                                  <br />
                                  <span className="text-white">
                                    {this.context.GetLicenseTypeNameById(
                                      this.context.store.storeTypeId
                                    )}
                                  </span>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </>
                    ) : (
                      <>
                        <div className="p-3 bg-light text-dark text-start CornersRoundedSmall">
                          <Row className="border-bottom">
                            <Col>Store Name</Col>
                            <Col> {this.context.store.name}</Col>
                          </Row>
                          <Row className="border-bottom">
                            <Col> Store Expires on</Col>
                            <Col>
                              {" "}
                              <span className="blink_me ">
                                {this.context.GetInDateFormat(
                                  new Date(this.context.store.storeEnd)
                                )}
                              </span>
                            </Col>
                          </Row>
                          <Row className="border-bottom">
                            <Col> Product Type</Col>
                            <Col>
                              <span className="">
                                {this.context.GetProductTypeNameById(
                                  this.context.store.productTypeId
                                )}
                              </span>
                            </Col>
                          </Row>
                          <Row className="border-bottom">
                            <Col> License Model</Col>
                            <Col>
                              <span className="">
                                {this.context.GetLicenseTypeNameById(
                                  this.context.store.storeTypeId
                                )}
                              </span>
                            </Col>
                          </Row>
                        </div>
                      </>
                    )}
                  </div>
                  {/* <hr /> */}
                  <Row className="align-items-center mb-3 bg-light p-2">
                    <Col xs={12} md={4}>
                      <h4 className="text-start mb-2 mb-md-0">SUMMARY</h4>
                    </Col>
                    <Col xs={12} md={5}>
                      <InputGroup>
                        <InputGroup.Text>
                          <h6 className="mb-0">Select Date Range</h6>
                        </InputGroup.Text>
                        <Form.Select
                          className="ms-1 bg-warning text-dark"
                          size="lg"
                          value={this.state.dateSelection}
                          onChange={(e) => this.OnDateSelectionChange(e)}
                        >
                          <option value="Custom">Custom</option>
                          <option value="Today">Today</option>
                          <option value="Yesterday">Yesterday</option>
                          <option value="Month">This Month</option>
                          <option value="This Year">This Year</option>
                          <option value="Last Year">Last Year</option>
                        </Form.Select>
                      </InputGroup>
                    </Col>
                    {this.state.dateSelection === "Custom" && (
                      <Col xs={12} md={3} className="mt-2 mt-md-0">
                        <DatePicker
                          format="dd-MMM-yy"
                          onChange={(e) => {
                            this.setState({ customDate: e }, () => {
                              this.LoadDashboard();
                            });
                          }}
                          value={this.state.customDate}
                        />
                      </Col>
                    )}
                  </Row>

                  {window.innerWidth > 1200 ? (
                    <>
                      <div className="table-responsive">
                        <Table
                          bordered
                          className={
                            window.innerWidth > 1200
                              ? "mb-3 fs-5 text-center"
                              : "mb-3 fs-6 text-center "
                          }
                        >
                          <thead className="bg-light">
                            <tr>
                              <th>Total Products</th>
                              <th>Total Customers</th>
                              <th>Total Sale Orders</th>
                              <th>Total Sales Revenue</th>
                              <th>Total Purchase Orders</th>
                              <th>Total Purchase Expense</th>
                            </tr>
                          </thead>
                          <tbody className="bg-white text-dark fw-bold fs-4">
                            <tr>
                              <td>
                                {this.state.dashboardSummary.totalProducts}
                              </td>
                              <td>
                                {this.state.dashboardSummary.totalCustomers}
                              </td>
                              <td>{this.state.dashboardSummary.totalOrders}</td>
                              <td>
                                {Math.round(
                                  this.state.dashboardSummary.totalRevenue,
                                  0
                                ).toLocaleString(
                                  this.context.storeSettings.defaultLocale,
                                  {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 1,
                                    style: "currency",
                                    currency:
                                      this.context.storeSettings
                                        .defaultCurrency,
                                  }
                                )}
                              </td>
                              <td>
                                {this.state.dashboardSummary.totalPurchases}
                              </td>
                              <td>
                                {Math.round(
                                  this.state.dashboardSummary
                                    .totalPurchaseAmount,
                                  0
                                ).toLocaleString(
                                  this.context.storeSettings.defaultLocale,
                                  {
                                    minimumFractionDigits: 0,
                                    maximumFractionDigits: 1,
                                    style: "currency",
                                    currency:
                                      this.context.storeSettings
                                        .defaultCurrency,
                                  }
                                )}
                              </td>
                            </tr>
                          </tbody>
                        </Table>
                      </div>
                    </>
                  ) : (
                    <>
                      <div className="container my-5 ">
                        <Row className="border  text-start">
                          <Col className="border">Total Products</Col>
                          <Col className="border ">
                            {this.state.dashboardSummary.totalProducts}
                          </Col>
                        </Row>
                        <Row className="border  text-start">
                          <Col className="border">Total Customers</Col>
                          <Col className="border ">
                            {this.state.dashboardSummary.totalCustomers}
                          </Col>
                        </Row>
                        <Row className="border  text-start">
                          <Col className="border">Total Sale Orders</Col>
                          <Col className="border ">
                            {this.state.dashboardSummary.totalOrders}
                          </Col>
                        </Row>
                        <Row className="border  text-start">
                          <Col className="border">Total Sales Revenue</Col>
                          <Col className="border ">
                            {Math.round(
                              this.state.dashboardSummary.totalRevenue,
                              0
                            ).toLocaleString(
                              this.context.storeSettings.defaultLocale,
                              {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 1,
                                style: "currency",
                                currency:
                                  this.context.storeSettings.defaultCurrency,
                              }
                            )}
                          </Col>
                        </Row>
                        <Row className="border  text-start">
                          <Col className="border">Total Purchase Orders</Col>
                          <Col className="border ">
                            {this.state.dashboardSummary.totalPurchases}
                          </Col>
                        </Row>
                        <Row className="border  text-start">
                          <Col className="border">Total Purchase Expense</Col>
                          <Col className="border ">
                            {Math.round(
                              this.state.dashboardSummary.totalPurchaseAmount,
                              0
                            ).toLocaleString(
                              this.context.storeSettings.defaultLocale,
                              {
                                minimumFractionDigits: 0,
                                maximumFractionDigits: 1,
                                style: "currency",
                                currency:
                                  this.context.storeSettings.defaultCurrency,
                              }
                            )}
                          </Col>
                        </Row>
                      </div>
                    </>
                  )}

                  <div className="text-center fw-bold">
                    <Row className="bg-light">
                      <Col className="text-center mx-3 mb-3 p-3 CornersRoundedMedium border bg-white CornersRounded">
                        <h5>Total Sale Orders</h5>
                        {this.state.orderSummary && (
                          <Bar
                            width={160}
                            height={60}
                            options={{
                              title: {
                                display: true,
                                text: "",
                                fontSize: 20,
                              },
                              legend: { display: true, position: "top" },
                            }}
                            data={this.state.orderSummary}
                          />
                        )}
                      </Col>
                      <Col className="text-center mx-3 mb-3 p-3 CornersRoundedMedium border bg-white">
                        <h5>Total Sale Revenue</h5>
                        {this.state.revenueSummary && (
                          <Bar
                            width={160}
                            height={60}
                            options={{
                              title: {
                                display: true,
                                text: "",
                                fontSize: 20,
                              },
                              legend: { display: true, position: "top" },
                            }}
                            data={this.state.revenueSummary}
                          />
                        )}
                      </Col>
                    </Row>
                    <Row className="bg-light">
                      <Col className="text-center mx-3  mb-3 p-3 CornersRoundedMedium border bg-white">
                        <h5>Product Purchase Orders (PO)</h5>
                        {this.state.purchaseOrderSummary && (
                          <Bar
                            width={160}
                            height={60}
                            options={{
                              responsive: true,
                              maintainAspectRatio: true,
                              title: {
                                display: true,
                                text: "",
                                fontSize: 20,
                              },
                              legend: { display: true, position: "top" },
                            }}
                            data={this.state.purchaseOrderSummary}
                          />
                        )}
                      </Col>
                      <Col className="text-center mx-3  mb-3 p-3 CornersRoundedMedium border bg-white">
                        <h5>Product Purchase Expenses</h5>
                        {this.state.purchaseOrderExpensesSummary && (
                          <Bar
                            width={160}
                            height={60}
                            options={{
                              responsive: true,
                              maintainAspectRatio: true,
                              title: {
                                display: true,
                                text: "",
                                fontSize: 15,
                              },
                              legend: { display: true, position: "top" },
                            }}
                            data={this.state.purchaseOrderExpensesSummary}
                          />
                        )}
                      </Col>
                      {this.context.storeSettings.isManufacturer == true ? (
                        <>
                          <Col className="text-center mx-3  mb-3 p-3 CornersRoundedMedium border bg-white">
                            <h5>Raw Materials Purchase Orders (PO)</h5>
                            {this.state.rawMaterialPurchaseOrderSummary && (
                              <Bar
                                width={160}
                                height={60}
                                options={{
                                  responsive: true,
                                  maintainAspectRatio: true,
                                  title: {
                                    display: true,
                                    text: "",
                                    fontSize: 20,
                                  },
                                  legend: { display: true, position: "top" },
                                }}
                                data={
                                  this.state.rawMaterialPurchaseOrderSummary
                                }
                              />
                            )}
                          </Col>
                          <Col className="text-center mx-3  mb-3 p-3 CornersRoundedMedium border bg-white">
                            <h5>Raw Materials Purchase Expenses Summary</h5>
                            {this.state
                              .rawMaterialPurchaseOrderExpensesSummary && (
                              <Bar
                                width={160}
                                height={60}
                                options={{
                                  responsive: true,
                                  maintainAspectRatio: true,
                                  title: {
                                    display: true,
                                    text: "",
                                    fontSize: 15,
                                  },
                                  legend: { display: true, position: "top" },
                                }}
                                data={
                                  this.state
                                    .rawMaterialPurchaseOrderExpensesSummary
                                }
                              />
                            )}
                          </Col>
                        </>
                      ) : (
                        <></>
                      )}
                    </Row>
                    <Row className="bg-light">
                      <Col className="text-center mx-3  mb-3 p-3 CornersRoundedMedium border bg-white">
                        <h5>Top 15 Selling Products</h5>
                        {this.state.topProductsSummary && (
                          <Line
                            width={160}
                            height={60}
                            options={{
                              responsive: true,
                              maintainAspectRatio: true,
                              title: {
                                display: true,
                                text: "",
                                fontSize: 15,
                              },
                              legend: { display: true, position: "top" },
                            }}
                            data={this.state.topProductsSummary}
                          />
                        )}
                      </Col>
                      <Col className="text-center mx-3  mb-3 p-3 CornersRoundedMedium border bg-white">
                        <h5>Newly Registered Customers</h5>
                        {this.state.customerSummary && (
                          <Bar
                            width={160}
                            height={60}
                            options={{
                              title: {
                                display: true,
                                text: "",
                                fontSize: 20,
                              },
                              legend: { display: true, position: "top" },
                            }}
                            data={this.state.customerSummary}
                          />
                        )}
                      </Col>
                      <Col className="text-center mx-3  mb-3 p-3 CornersRoundedMedium  border bg-white">
                        <h5>Customers Accessed Online Store</h5>
                        {this.state.totalCustomerAccessSummary && (
                          <Bar
                            width={160}
                            height={60}
                            options={{
                              title: {
                                display: true,
                                text: "",
                                fontSize: 20,
                              },
                              legend: { display: true, position: "top" },
                            }}
                            data={this.state.totalCustomerAccessSummary}
                          />
                        )}
                      </Col>
                    </Row>
                  </div>
                </Col>
              </Row>
            </>
          ) : (
            ""
          )}
        </div>
        <iframe
          style={{ display: "none", width: "0", height: "0" }}
          onLoad={(e) => this.divLoaded(e)}
        ></iframe>
      </>
    );
  }
}

class ElasticCartAd extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }
  render() {
    return (
      <>
        <Modal
          {...this.props}
          size="lg"
          // aria-labelledby="contained-modal-title-vcenter"
          centered
          // backdrop="static"
          // keyboard={false}
          show={true}
          className="spinnermodal-backdrop m-0 p-0 bg-white  border-0"
          // dialogClassName="payByCash"
        >
          <Modal.Body
            className="text-center m-0 p-0 bg-white border-0"
            style={{ backgroundColor: "transparant" }}
          >
            <div className="text-center m-0 p-0 border-0">
              {/* <h1>Welcome to ElasticCART!</h1> */}
              <img
                src="./elasticcartad.png"
                className="w-100 CornersRounded border-0"
                alt="..."
                width="100%"
                // height="500"
                style={{ objectFit: "contain" }}
              />{" "}
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}
